module.exports = __webpack_public_path__ + "img/tr_tr2.e9896c55.png";